import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "currentColor",
      "fill-rule": "nonzero",
      class: "broadcast-svg-fill"
    }, [
      _createElementVNode("path", { d: "M20.343 10c-.575 0-1.042.448-1.042 1v1c0 3.866-3.264 7-7.291 7s-7.292-3.134-7.292-7v-1c0-.552-.466-1-1.042-1-.575 0-1.041.448-1.041 1v1c0 4.633 3.646 8.447 8.333 8.945V22H8.885c-.576 0-1.042.448-1.042 1s.466 1 1.042 1h6.25c.575 0 1.041-.447 1.041-1s-.466-1-1.041-1H13.05v-1.055c4.687-.498 8.334-4.312 8.334-8.945v-1c0-.552-.467-1-1.042-1z" }),
      _createElementVNode("path", { d: "M12.01 18c3.451 0 6.25-2.687 6.25-6V6c0-3.313-2.799-6-6.25-6S5.76 2.687 5.76 6v6c0 3.313 2.799 6 6.25 6M7.843 6c0-2.209 1.866-4 4.167-4s4.167 1.791 4.167 4v6c0 2.209-1.866 4-4.167 4s-4.167-1.791-4.167-4z" }),
      _createElementVNode("path", { d: "M10.968 12h2.084c.575 0 1.041-.448 1.041-1s-.466-1-1.041-1h-2.084c-.575 0-1.041.448-1.041 1s.466 1 1.041 1M10.968 8h2.084c.575 0 1.041-.448 1.041-1s-.466-1-1.041-1h-2.084c-.575 0-1.041.448-1.041 1s.466 1 1.041 1" })
    ], -1)
  ])))
}
export default { render: render }